import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerNeurologia'; 
import AboutNeurologista from './AboutNeurologista';
import CorpoClinico from './CorpoClinico';
import "../../styles/psicomotricidade.css";
import "../../styles/footer.css";

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutNeurologista />
        <CorpoClinico />
      </div>
    );
  };
  
  export default About;
  